<template>
  <thead class="default-table-header" :style="custom_style" v-bind="$attrs">
    <slot></slot>
  </thead>
</template>

<script lang="ts">
export default {
  props: {
    custom_style: {
      default: '',
      required: false,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.default-table-header {
  font-weight: bold;
  border-bottom: 2px solid gray;
  background-color: #fff;
  height: 50px;
  position: sticky;
  top: 0px;
  z-index: 10;
}
</style>
